import React, { useState, useEffect } from "react";

import { Link, useNavigate } from "react-router-dom";


import { getContent } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import Header from "Component/Header/Header";
import Footer from "Component/Footer/Footer";
import { Container } from "react-bootstrap";
import Loader from "Component/Common/Loader";
import Skeleton from 'react-loading-skeleton';
import useToastr from "helpers/toastr";
import parse from 'html-react-parser';


const Content = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [contentInfo, setContentInfo] = useState();
  let urlPath = window.location.pathname.split("/");
  let path = urlPath[1];
  const { loading } = useSelector((state) => state?.Content);
  const toastr = useToastr();

  const getContentFnc = () => {



    const callBack = (response) => {
      if (response.status == "success") {
        setContentInfo(response?.data)
      }
    }
    dispatch(getContent({ data: path }, callBack))
  }

 /**
     * Used for calling the privacy-policy and terms-conditions api
     */
  useEffect(() => {
   
    getContentFnc();

  }, [path])

  const handleBack = () => {
    navigate(-1);
  }

 /**
     * Used for render the privacy-policy and terms-conditions UI
     */
  return (
    <div>

      <Header/>
        <section className="terms-of-service home_banner_main buy_page position-relative text-start">
       
        
              <Container>
              {/* <Link to="" className="arrow_back" onClick={handleBack}>
          <svg role="button"  width="30" height="30" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M13 5H1m0 0 4 4M1 5l4-4" />
                </svg>  
          </Link> */}
                  <div className="content_inner text-start mt-5">
                    {loading ? <Skeleton width={"80%"} height={28} />  :
                     <h2 className="mb-4">{contentInfo?.title}</h2>}
                     {loading ? <Skeleton width={"80%"} height={150} /> :
                       contentInfo?.content && parse(contentInfo?.content)} 
                     
                  </div>   
              </Container>
        </section>
      <Footer/>
    </div>
  );
};

export default Content;
